export default __webpack_public_path__ + "static/media/google-logo.2760eed1.png";